import { createSelector } from 'reselect';
import { RootState } from '../../../types';

const register = (state: RootState) => state.register;

export const selectRegister = createSelector([register], register => {
  return register;
});
